import axios from "axios"
async function getTokenAsync(val) {
    let isSimple = true
    let isCustom = false
    let customColor = ''
    let custom = ''
        // let URL = "http://cdp-local-web.test.routeryuncs.com"
        // let URL = location.protocol + '//' + window.location.href.split('/')[2]+ '/'
    //     const request = axios.get(`/routeryun/open/getAppTextConfig`);
    //     await request.then((response) => {

    //     if(response.headers.hasOwnProperty('clientcustom')){
    //         isCustom = true
    //         switch (response.headers.clientcustom) {
    //             case 'xugong':
    //                 customColor = '#074CA1'
    //                 custom = 'xugong'
    //                 isSimple = false
    //                 break;
    //             case 'weichuang':
    //                 customColor = '#042A72'
    //                 custom = 'weichuang'
    //                 isSimple = false
    //                 break;

    //             case 'xzrb':
    //                 isCustom = false
    //                 custom = 'xzrb'
    //                 isSimple = false
    //                 break;
            
    //             default:
    //                 isCustom = false
    //                 if (response.headers.applicationmode == 'complete') {
    //                     isSimple = false
    //                 } else {
    //                     isSimple = true
    //                 }
    //                 break;
    //         }
            
    //     }else{
    //         if (response.headers.applicationmode == 'complete') {
    //             isSimple = false
    //         } else {
    //             isSimple = true
    //         }
    //     }
    // });
    const requestOther = axios.get(`/api/open/getAppTextConfig`);
    await requestOther.then((response) => {
        if(response.headers.hasOwnProperty('clientcustom')){
            isCustom = true
            switch (response.headers.clientcustom) {
                case 'xugong':
                    customColor = '#074CA1'
                    custom = 'xugong'
                    isSimple = false
                    break;
                case 'weichuang':
                    customColor = '#042A72'
                    custom = 'weichuang'
                    isSimple = false
                    break;
                    case 'xzrb':
                        isCustom = false
                        custom = 'xzrb'
                        isSimple = false
                        break;
            
                default:
                    isCustom = false
                    if (response.headers.applicationmode == 'complete') {
                        isSimple = false
                    } else {
                        isSimple = true
                    }
                    break;
            }
            
        }else{
            if (response.headers.applicationmode == 'complete') {
                isSimple = false
            } else {
                isSimple = true
            }
        }
        // if (response.headers.applicationmode == 'complete') {
        //     isSimple = false
        // } else {
        //     isSimple = true
        // }
    })
    return {isSimple,isCustom,customColor,custom}

}

export default getTokenAsync
// console.log(isSimple);